module.exports = __webpack_public_path__ + "static/media/7.Manual Lawnmower.04ad7600.webp";